import { mapValues } from 'radash';
import { heights } from './heights.js';

/**
 * Collection of design tokens for border radiuses. We're deriving the tokens from the height
 * tokens, so that equally sized elements have the same radius.
 */ const borderRadiuses = {
    none: 0,
    ...mapValues(heights, (value)=>value / 4),
    round: 9_999
};

export { borderRadiuses };
//# sourceMappingURL=border-radiuses.js.map
